const BackendConfig = {
  Url: (): string => "/backendproxy",
};

export default BackendConfig;
